(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[330],{

/***/ 38849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgVergleichangebot = function SvgVergleichangebot(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 284.5 285",
    style: {
      enableBackground: "new 0 0 284.5 285"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M273.6 201.9c0 20-9.8 38.7-26.3 50.1l-30 20.8-30-20.8c-16.4-11.4-26.3-30.1-26.3-50.1v-44.8c21.1 1.4 41.6-6.5 56.2-21.6 14.7 15.2 35.2 23 56.2 21.6v44.8zM11.1 11.3h154.7v42.2c0 2.6 2.1 4.7 4.7 4.7h42.2v68.5c-13.7 15.6-33.9 23.4-54.5 20.8l-1.2-.1c-.2 0-.4.1-.6.1v-.1h-46.9v9.4h42.2v9.4h-75v9.4h75V199H95.5v9.4h56.6c.3 3.2.7 6.3 1.4 9.4H29.9v9.4h126.5c1.2 3.2 2.8 6.4 4.5 9.4h-37.2v9.4h43.6c4.2 5.3 9.1 10.1 14.8 14l20.3 14.1H11.1V11.3zm195 37.5h-30.9V17.9l30.9 30.9zm75.3 99.6c-1-.9-2.3-1.3-3.7-1.1l-1.2.1c-20.6 2.6-40.9-5.2-54.5-20.8V53.4c0-.1-.1-.2-.1-.3 0-.4-.1-.8-.2-1.2-.1-.1-.1-.3-.2-.4-.2-.5-.5-1-.9-1.4L173.8 3.3c-.4-.4-.9-.7-1.4-.9-.1-.1-.3-.1-.5-.2-.3-.2-.7-.2-1.1-.2-.1 0-.2-.1-.3-.1H6.4C3.9 1.9 1.8 4 1.8 6.6v271.9c0 2.6 2.1 4.7 4.7 4.7h210.9c.9 0 1.9-.3 2.7-.8l32.7-22.6c19-13.1 30.3-34.7 30.3-57.8v-50c-.1-1.5-.7-2.7-1.7-3.6"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M254.9 201.9c0 13.8-6.8 26.8-18.2 34.7L217.4 250l-19.3-13.4c-11.4-7.9-18.2-20.9-18.2-34.7v-27c13.5-2.1 26.3-7.2 37.5-15 11.2 7.7 24 12.9 37.5 15v27zm5.2-35.8c-14.5-1.6-28.3-7-39.9-15.7-1.7-1.2-4-1.2-5.6 0-11.6 8.7-25.4 14.2-39.9 15.7-2.4.3-4.2 2.2-4.2 4.6v31.1c0 16.9 8.3 32.8 22.2 42.4l22 15.2c.8.5 1.7.8 2.7.8s1.9-.3 2.7-.8l22-15.2c13.9-9.6 22.2-25.5 22.2-42.4v-31.1c-.1-2.3-1.9-4.3-4.2-4.6"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m196.7 209.1-5.6 7.5 18.8 14.1c.8.6 1.8.9 2.8.9 1.4 0 2.8-.6 3.7-1.8l32.8-42.2-7.4-5.8-30 38.5-15.1-11.2M147.1 25.3h-75v9.4h75v-9.4M147.1 44.1h-75v9.4h75v-9.4M100.2 72.2H29.9v9.4h70.3v-9.4M123.6 90.9H29.9v9.4h93.8v-9.4M118.9 109.7h-89v9.4H119v-9.4M109.6 81.6H194v-9.4h-84.4v9.4M133 100.3h60.9v-9.4H133v9.4M133 109.7h-4.7v9.4h65.6v-9.4H133M193.9 128.4h-164v9.4H194v-9.4M100.2 147.2H29.9v9.4h70.3v-9.4M86.1 198.8H29.9v9.4h56.2v-9.4M67.4 165.9H29.9v9.4h37.5v-9.4M29.9 245.6h84.4v-9.4H29.9v9.4"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgVergleichangebot);

/***/ }),

/***/ 84459:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...slug]",
      function () {
        return __webpack_require__(97787);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SwiperOfferSlider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88494);
/* harmony import */ var swiper_css_bundle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72821);
/* harmony import */ var swiper_css_bundle__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(swiper_css_bundle__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(965);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);

// eslint-disable-next-line import/no-unresolved

// eslint-disable-next-line import/no-unresolved




function SwiperOfferSlider(param) {
    var items = param.items;
    var ref;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: items && items.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .Swiper */ .tq, {
            slidesPerView: 3,
            spaceBetween: 10,
            loop: true,
            breakpoints: {
                '@0.1': {
                    slidesPerView: 1
                },
                '@0.75': {
                    slidesPerView: 2
                },
                '@1.00': {
                    slidesPerView: 3
                }
            },
            modules: [
                swiper__WEBPACK_IMPORTED_MODULE_3__/* .Navigation */ .W_
            ],
            navigation: true,
            className: "w-full",
            children: items.map(function(item, k) {
                var ref2, ref1;
                // eslint-disable-next-line react/jsx-no-useless-fragment
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: item.thumbnail.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .SwiperSlide */ .o5, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_5__["default"], {
                            href: item.link,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "relative group h-[250px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                            src: item.thumbnail[0].publicUrl,
                                            alt: (ref = (ref2 = item.thumbnail[0]) === null || ref2 === void 0 ? void 0 : (ref1 = ref2.properties) === null || ref1 === void 0 ? void 0 : ref1.alternative) !== null && ref !== void 0 ? ref : '',
                                            layout: "fill",
                                            objectFit: "cover"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "absolute text-primary z-20 bg-action group-hover:bg-primary group-hover:text-action right-0 bottom-0 px-3 py-2",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "cms-offer-text",
                                                dangerouslySetInnerHTML: {
                                                    __html: item.offer
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }, k)
                });
            })
        })
    }));
};


/***/ }),

/***/ 51190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ UserErrorPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_helper_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89388);
/* harmony import */ var _components_elements_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81474);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var _components_helper_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34892);





function UserErrorPage(param) {
    var statusCode = param.statusCode, _title = param.title, title = _title === void 0 ? 'Seite nicht gefunden' : _title;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_helper_seo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                title: "".concat(statusCode || 'Ups!', " - ").concat(title)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "max-w-7xl mx-auto w-full px-6 py-6 lg:py-4 xl:px-0 relative overflow-hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "grid md:grid-cols-2 min-h-screen",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col items-start justify-center relative",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    className: "my-2 font-bold text-4xl",
                                    children: "Es ist ein Fehler aufgetreten - bitte entschuldigen Sie."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "my-2 text-gray-800 mb-20 text-lg",
                                    children: [
                                        "Sie k\xf6nnen den Vorgang wiederholen oder unser",
                                        ' ',
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_helper_link__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            href: "/kontakt",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: "underline",
                                                children: "Kontaktformular"
                                            })
                                        }),
                                        ' ',
                                        "nutzen."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    href: "/",
                                    variant: "primary",
                                    children: "Zur Startseite"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    style: {
                                        fontSize: '20rem'
                                    },
                                    className: "font-bold text-primary-700 pointer-events-none opacity-10 absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2",
                                    children: statusCode
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex-col items-center justify-center hidden md:flex",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                src: "/images/Group.png",
                                width: 300,
                                alt: "Broke",
                                height: 200,
                                objectFit: "contain"
                            })
                        })
                    ]
                })
            })
        ]
    }));
};


/***/ }),

/***/ 97787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ RenderPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-schemaorg/dist/src/index.js
var src = __webpack_require__(45363);
// EXTERNAL MODULE: ./src/components/helper/seo.js
var seo = __webpack_require__(89388);
// EXTERNAL MODULE: ./src/components/content/hero.js
var hero = __webpack_require__(80384);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./src/components/content/cruise-slider.js
var cruise_slider = __webpack_require__(15948);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-bundle.min.css
var swiper_bundle_min = __webpack_require__(72821);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 89 modules
var swiper_esm = __webpack_require__(965);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./src/components/helper/link.js
var helper_link = __webpack_require__(34892);
// EXTERNAL MODULE: ./src/components/helper/image.js + 1 modules
var helper_image = __webpack_require__(1075);
// EXTERNAL MODULE: ./src/lib/connect.js
var connect = __webpack_require__(43424);
// EXTERNAL MODULE: ./public/assets/icons/anker/user.svg
var user = __webpack_require__(68395);
// EXTERNAL MODULE: ./public/assets/icons/anker/bed.svg
var bed = __webpack_require__(6231);
// EXTERNAL MODULE: ./public/assets/icons/anker/length.svg
var anker_length = __webpack_require__(54319);
// EXTERNAL MODULE: ./public/assets/icons/anker/port.svg
var port = __webpack_require__(20614);
;// CONCATENATED MODULE: ./src/components/content/boat-slider.js

// eslint-disable-next-line import/no-unresolved

// eslint-disable-next-line import/no-unresolved











function BoatSlider(param) {
    var searchQueryParams = param.searchQueryParams;
    var ref = (0,react.useState)([]), boats = ref[0], setBoats = ref[1];
    (0,react.useEffect)(function() {
        var params = searchQueryParams;
        if ((searchQueryParams === null || searchQueryParams === void 0 ? void 0 : searchQueryParams.limit) === undefined) {
            params.limit = 10;
        }
        (0,connect/* fetchAPI */.Io)('/boat', params).then(function(data) {
            setBoats(data.data);
        });
    }, [
        searchQueryParams
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: boats.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            slidesPerView: 3,
            spaceBetween: 10,
            loop: true,
            breakpoints: {
                '@0.1': {
                    slidesPerView: 1
                },
                '@0.75': {
                    slidesPerView: 2
                },
                '@1.00': {
                    slidesPerView: 3
                }
            },
            modules: [
                swiper_esm/* Navigation */.W_
            ],
            navigation: true,
            className: "w-full",
            children: boats.map(function(boat, k) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
                        href: {
                            pathname: "/yacht/".concat(boat.slug)
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-primary cursor-pointer",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    className: "p-1 pb-0 font-bold bg-action text-center",
                                    children: boat.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                    src: (0,helper_image/* default */.Z)(boat.photo_url),
                                    layout: "responsive",
                                    width: "400",
                                    height: "250",
                                    className: "object-cover",
                                    alt: boat.title,
                                    title: boat.title
                                }),
                                boat.license === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "-mt-7 w-3/5 relative bg-primary bg-opacity-75 text-white text-sm p-1 text-center",
                                    children: "auch ohne F\xfchrerschein"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative p-2 bg-gray-200",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(port/* default */.Z, {
                                                    className: "mr-2 ml-0.5 fill-primary",
                                                    width: 12
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "line-clamp-1",
                                                    children: boat.basements[0].location.half
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: " basis-1/3 ",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(user/* default */.Z, {
                                                                    height: 14,
                                                                    className: "mr-1 fill-primary"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "font-semibold",
                                                                    children: "Kojen"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "ml-5",
                                                            children: [
                                                                boat.berth.fixed,
                                                                "(+",
                                                                boat.berth.variable,
                                                                ")"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "basis-1/3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(bed/* default */.Z, {
                                                                    height: 14,
                                                                    className: "mx-1 fill-primary"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "font-semibold",
                                                                    children: "Kabinen"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "ml-5",
                                                            children: boat.cabins
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "basis-1/3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(anker_length/* default */.Z, {
                                                                    height: 14,
                                                                    className: "mx-1 fill-primary"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "font-semibold",
                                                                    children: "L\xe4nge"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "ml-5",
                                                            children: [
                                                                boat.length,
                                                                "\xa0m"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-right font-bold pr-2 w-1/2 bg-primary text-white relative left-1/2",
                                        children: [
                                            "Schon ab",
                                            ' ',
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                children: [
                                                    boat.min_price,
                                                    "\xa0€"
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                }, k);
            })
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js
var disclosure = __webpack_require__(6512);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(61782);
// EXTERNAL MODULE: ./src/components/content/headline.js + 1 modules
var headline = __webpack_require__(17587);
;// CONCATENATED MODULE: ./src/components/content/faq-grouped.js





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(' ');
}
function FaqGrouped(param1) {
    var items = param1.items;
    var json = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: []
    };
    items.forEach(function(g) {
        g.items.forEach(function(i) {
            json.mainEntity.push({
                '@type': 'Question',
                name: i.question,
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: i.answer
                }
            });
        });
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", _objectSpread({}, (0,src/* jsonLdScriptProps */.h6)(json))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-2 gap-10",
                children: items.map(function(g) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-14",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: " divide-y-2 divide-gray-200",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(headline/* default */.Z, {
                                        children: g.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                                        className: "mt-6 space-y-4 divide-y divide-gray-200",
                                        children: g.items.map(function(faq) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
                                                as: "div",
                                                className: "pt-4",
                                                children: function(param) {
                                                    var open = param.open;
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                className: "text-lg",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Button */.p.Button, {
                                                                    className: "text-left w-full flex justify-between items-start text-gray-400",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                            className: "font-semibold text-gray-900",
                                                                            children: faq.question
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "ml-6 h-6 flex items-center",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
                                                                                className: classNames(open ? '-rotate-180' : 'rotate-0', 'h-6 w-6 transform'),
                                                                                "aria-hidden": "true"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, {
                                                                as: "dd",
                                                                className: "mt-2 pr-12",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "text-base",
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: faq.answer
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    });
                                                }
                                            }, faq.question);
                                        })
                                    })
                                ]
                            })
                        })
                    }, g.name);
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./node_modules/@heroicons/react/solid/esm/ArrowNarrowLeftIcon.js


function ArrowNarrowLeftIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react.forwardRef(ArrowNarrowLeftIcon);
/* harmony default export */ var esm_ArrowNarrowLeftIcon = (ForwardRef);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/solid/esm/ArrowNarrowRightIcon.js


function ArrowNarrowRightIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z",
    clipRule: "evenodd"
  }));
}

const ArrowNarrowRightIcon_ForwardRef = react.forwardRef(ArrowNarrowRightIcon);
/* harmony default export */ var esm_ArrowNarrowRightIcon = (ArrowNarrowRightIcon_ForwardRef);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
;// CONCATENATED MODULE: ./src/components/elements/pagination-alternative.js

/* This example requires Tailwind CSS v2.0+ */ 


function PaginationAlternative(param) {
    var pagination = param.pagination, _position = param.position, position = _position === void 0 ? 'bottom' : _position;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                children: [
                    pagination.prev && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "prev",
                        href: pagination.prev
                    }),
                    pagination.next && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "next",
                        href: pagination.next
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                className: "".concat(position === 'bottom' ? 'border-t mt-5' : 'border-b mb-5', " border-gray-200 px-4 flex items-center justify-between sm:px-0"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "-mt-1 w-0 flex-1 flex",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
                            href: pagination.prev || pagination.first,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "".concat(position === 'bottom' ? 'border-t pt-4' : 'border-b pb-4', " border-transparent pr-1 inline-flex items-center text-md font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ArrowNarrowLeftIcon, {
                                        className: "mr-3 h-5 w-5 text-gray-400",
                                        "aria-hidden": "true"
                                    }),
                                    "zur\xfcck"
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(position === 'bottom' ? 'md:-mt-px' : 'md:-mb-px', " hidden md:flex"),
                        children: pagination.pages.map(function(i) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", {
                                href: i.link,
                                className: "".concat(position === 'bottom' ? 'border-t pt-4' : 'border-b pb-4', " px-4 inline-flex items-center text-md font-medium ").concat(i.current ? 'border-primary-500 text-primary-600' : 'text-gray-500 hover:text-gray-700'),
                                children: i.page
                            }, i.page);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "-mt-px w-0 flex-1 flex justify-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
                            href: pagination.next || pagination.last,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "".concat(position === 'bottom' ? 'border-t pt-4' : 'border-b pb-4', " border-transparent pl-1 inline-flex items-center text-md font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300"),
                                children: [
                                    "weiter",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ArrowNarrowRightIcon, {
                                        className: "ml-3 h-5 w-5 text-gray-400",
                                        "aria-hidden": "true"
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/content/news-list.js





function readingTime(text) {
    var wpm = 225;
    var words = text.trim().split(/\s+/).length;
    return Math.ceil(words / wpm);
}
function NewsList(param) {
    var item = param.item, page = param.page;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationAlternative, {
                pagination: item.content.data.pagination,
                position: "top"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid gap-5 lg:grid-cols-3",
                children: item.content.data.list.map(function(post) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col shadow-lg overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
                                href: "".concat(post.slug),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "flex-shrink-0",
                                    children: post.media.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        height: "300",
                                        width: "500",
                                        src: (0,helper_image/* default */.Z)(post.media[0].images.defaultImage.publicUrl),
                                        objectFit: "cover",
                                        alt: post.media[0].properties.alternative,
                                        title: post.media[0].properties.title
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex-1 bg-white p-6 flex flex-col justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-sm font-medium text-primary-600",
                                                children: post.categories.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
                                                    href: "".concat(page.slug, "/").concat(post.categories[0].slug),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "hover:underline",
                                                        children: post.categories[0].title
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "-"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
                                                href: "".concat(post.slug),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    className: "block mt-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            className: "text-xl font-semibold text-gray-900",
                                                            children: post.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "mt-3 text-base text-gray-500",
                                                            children: post.teaser
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-6 flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex-shrink-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "sr-only",
                                                            children: post.author.author
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                            height: 50,
                                                            width: 50,
                                                            className: "rounded-full",
                                                            src: "/icons/favicon.svg",
                                                            alt: post.title,
                                                            title: post.title
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "ml-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-sm font-medium text-gray-900",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "_hover:underline",
                                                            children: post.author.author
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex space-x-1 text-sm text-gray-500",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                                            dateTime: post.created_at,
                                                            children: post.crdate
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, post.title);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationAlternative, {
                pagination: item.content.data.pagination
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
;// CONCATENATED MODULE: ./src/components/content/offer-list.js



function OfferList(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items;
    var ref;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "grid gap-5 md:grid-cols-2 lg:grid-cols-3",
        children: items.map(function(item, k) {
            var ref3, ref1, ref2;
            // eslint-disable-next-line react/jsx-no-useless-fragment
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: item.thumbnail.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                    className: "flex flex-col shadow-lg overflow-hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: item.link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative w-full h-[200px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: item.thumbnail[0].publicUrl,
                                        alt: (ref = (ref3 = item.thumbnail[0]) === null || ref3 === void 0 ? void 0 : (ref1 = ref3.properties) === null || ref1 === void 0 ? void 0 : ref1.alternative) !== null && ref !== void 0 ? ref : '',
                                        layout: "fill",
                                        objectFit: "cover"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "p-6 bg-white",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-xl font-semibold text-gray-900",
                                            children: item.title
                                        }),
                                        (item === null || item === void 0 ? void 0 : (ref2 = item.abstract) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-3 text-base text-gray-500 mt-2",
                                            dangerouslySetInnerHTML: {
                                                __html: item.abstract
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }, k)
                })
            });
        })
    }));
};

// EXTERNAL MODULE: ./src/components/content/swiper-offer-slider.js
var swiper_offer_slider = __webpack_require__(25729);
;// CONCATENATED MODULE: ./src/components/content/carousel.js

// eslint-disable-next-line import/no-unresolved

// eslint-disable-next-line import/no-unresolved



function Carousel(param) {
    var item = param.item;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "max-w-3xl",
        children: item.content.items.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            slidesPerView: 1,
            spaceBetween: 0,
            breakpoints: {
                '@0.1': {
                    slidesPerView: 1
                },
                '@0.75': {
                    slidesPerView: 1
                },
                '@1.00': {
                    slidesPerView: 1
                }
            },
            modules: [
                swiper_esm/* Navigation */.W_
            ],
            navigation: true,
            className: "w-full",
            children: item.content.items.map(function(slide, k) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative block p-10",
                        children: [
                            ((ref = slide.backgroundImage[0]) === null || ref === void 0 ? void 0 : ref.publicUrl) !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                src: slide.backgroundImage[0].publicUrl,
                                layout: "fill",
                                objectFit: "cover"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "block w-full max-w-lg bg-white bg-opacity-90 p-10 z-10 relative ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-4xl font-semibold text-primary mb-2",
                                        children: slide.header
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-lg",
                                        dangerouslySetInnerHTML: {
                                            __html: slide.bodytext
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "bg-primary text-white mt-4 py-2 px-3 text-2xl font-bold",
                                        children: slide.buttonText
                                    })
                                ]
                            })
                        ]
                    })
                }, k);
            })
        })
    }));
};

;// CONCATENATED MODULE: ./node_modules/@heroicons/react/solid/esm/PlusIcon.js


function PlusIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
    clipRule: "evenodd"
  }));
}

const PlusIcon_ForwardRef = react.forwardRef(PlusIcon);
/* harmony default export */ var esm_PlusIcon = (PlusIcon_ForwardRef);
;// CONCATENATED MODULE: ./src/components/content/features.js


function Features(param) {
    var items = param.items;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "grid lg:grid-cols-4 md:grid-cols-2 gap-2 w-full",
        children: items.map(function(v) {
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-3 pr-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_PlusIcon, {
                                className: "h-8 text-action"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "font-semibold py-3 text-xl",
                                children: v.header
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg:text-base text-sm font-extralight",
                                dangerouslySetInnerHTML: {
                                    __html: v.bodytext
                                }
                            })
                        ]
                    })
                ]
            }, v.header);
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/ChevronRightIcon.js
var ChevronRightIcon = __webpack_require__(40169);
;// CONCATENATED MODULE: ./src/components/elements/slider.js


function Slider(param) {
    var items = param.items;
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(480), siteWidth = ref1[0], setSiteWidth = ref1[1];
    var ref2 = (0,react.useState)(380), maxWidth = ref2[0], setMaxWidth = ref2[1];
    var ref3 = (0,react.useState)(0), currentOffset = ref3[0], setCurrentOffset = ref3[1];
    var ref4 = (0,react.useState)(150), itemWidth = ref4[0], setItemWidth = ref4[1];
    (0,react.useEffect)(function() {
        if (ref.current) {
            var amount = ref.current.children.length;
            setSiteWidth(ref.current.clientWidth);
            setMaxWidth(amount * ref.current.firstChild.clientWidth + 12);
            setItemWidth(ref.current.firstChild.clientWidth + 16);
        }
    }, [
        ref.current
    ]);
    var next = function() {
        if (currentOffset < maxWidth - siteWidth) {
            setCurrentOffset(currentOffset + itemWidth);
        } else {
            setCurrentOffset(0);
        }
    };
    var prev = function() {
        if (currentOffset > 0) {
            setCurrentOffset(currentOffset - itemWidth);
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute right-0 -top-24 pt-10 pb-1 space-x-8 lg:flex hidden lg:visible",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "bg-transparent border-none appearance-none",
                        onClick: prev,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 7 12",
                            className: "".concat(currentOffset > 0 ? 'text-primary-500' : 'text-gray-300', " w-6 h-6"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M5.962.482L1.218 5.226l-.431.431c-.026.026-.178.127-.178.178-.025.127.38.431.457.507.913.965 1.826 1.929 2.765 2.867.71.761 1.446 1.497 2.156 2.258.254.254-.152.66-.405.406C3.983 10.2 2.385 8.524.762 6.85.583 6.647.38 6.47.202 6.266c-.38-.43-.025-.786.254-1.09L3.222 2.41 5.556.076c.254-.254.66.152.406.406z",
                                fill: "currentColor"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "bg-transparent border-none appearance-none",
                        onClick: next,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 6 12",
                            className: "text-primary-500 w-6 h-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M.076.482L4.82 5.226l.431.431c.026.026.178.127.178.178.025.127-.38.431-.457.507-.913.965-1.826 1.929-2.765 2.867-.71.761-1.446 1.497-2.156 2.258-.254.254.152.66.406.406C2.055 10.2 3.653 8.524 5.277 6.85c.177-.203.38-.38.558-.584.38-.43.025-.786-.254-1.09L2.816 2.41.482.076C.228-.178-.178.228.076.482z",
                                fill: "currentColor"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: " lg:overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    ref: ref,
                    style: {
                        transform: "translateX(".concat(-currentOffset, "px)")
                    },
                    className: "grid grid-flow-col justify-items-start grid-rows-1 gap-4 overflow-y-hidden overflow-x-auto lg:overflow-visible transition-transform duration-500 ease-in-out",
                    children: items.map(function(item, k) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                            children: item
                        }, k);
                    })
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/content/topic-slider.js





function TopicSlider(param) {
    var item1 = param.item;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "pt-4 pb-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(headline/* default */.Z, {
                    tag: item1.content.headerLayout || 2,
                    after: item1.content.suffix,
                    before: item1.content.prefix,
                    className: "mb-2",
                    children: item1.content.header
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, {
                items: item1.content.items.map(function(item) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
                        href: item.link.href,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "group overflow-hidden w-slider-item lg:w-slider-item-lg bg-primary-300 text-white flex px-8 pt-8 pb-0 h-full cursor-pointer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        className: "text-lg font-bold uppercase leading-5 text-action",
                                        children: item.header
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "py-4 h-full",
                                        dangerouslySetInnerHTML: {
                                            __html: item.bodytext
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "block",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "transition-all duration-300 bg-action text-primary px-3 py-2 w-2/3 flex items-center justify-center font-semibold text-sm uppercase group-hover:bg-action-400",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRightIcon/* default */.Z, {
                                                    className: "h-3 mr-2"
                                                }),
                                                ' ',
                                                item.linkTitle
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }, item.header);
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/content/faq.js
var faq = __webpack_require__(58130);
// EXTERNAL MODULE: ./src/components/elements/button.js
var elements_button = __webpack_require__(81474);
;// CONCATENATED MODULE: ./src/components/content/toc.js



function TableOfContents(param) {
    var items = param.items;
    if (!items.length) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-gray-100 p-5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mb-3 text-xl text-primary ml-5",
                children: "Themenbereiche"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "grid grid-cols-1 grid-flow-row text-sm place-content-between divide-white divide-y",
                children: items.map(function(i, k) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(modules/* Link */.rU, {
                            className: "flex py-1.5 hover:text-primary hover:font-semibold",
                            to: "".concat(i.id),
                            smooth: true,
                            offset: -100,
                            duration: 500,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRightIcon/* default */.Z, {
                                    className: "text-action h-4 mr-2 mt-0.5 flex-shrink-0"
                                }),
                                ' ',
                                i.title
                            ]
                        })
                    }, k);
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/content/items/offer.js



function OfferItem(param) {
    var title = param.title, description = param.description, price = param.price, _prefix = param.prefix, prefix = _prefix === void 0 ? 'ab' : _prefix, image = param.image, href = param.href;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "transition-all duration-200 block relative h-60 group",
            title: title,
            target: "_blank",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                    src: image,
                    alt: title,
                    title: title,
                    layout: "fill",
                    objectFit: "cover"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "transition bg-action text-primary absolute inset-y-0 right-0 left-[50%] md:left-[55%] p-3 md:p-5 flex flex-col group-hover:bg-primary-300 group-hover:text-action",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-xl uppercase font-bold mb-3",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-base",
                            children: description
                        }),
                        price !== null && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-auto text-sm",
                                    children: prefix
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-4xl font-bold",
                                    children: price
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/content/divider.js

function Divider(param) {
    var _variant = param.variant, variant = _variant === void 0 ? 'simple' : _variant;
    if (variant === 'simple') {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "h-0.5 my-6 mx-12 border border-gray-200"
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: "wave"
    }));
};

;// CONCATENATED MODULE: ./src/components/content/items/feature-card.js


function FeatureCard(param) {
    var title = param.title, icon = param.icon, href = param.href;
    var IconImage = icon;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "grid grid-cols-2 group",
            title: title,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-action text-primary px-4 py-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconImage, {
                        className: "w-full"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bg-primary text-white text-xl font-bold flex flex-col items-center px-5 py-6 text-center uppercase",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            fill: "currentColor",
                            className: "transition-all duration-500 group-hover:text-action h-22 bi bi-arrow-right mt-3 group-hover:translate-x-3",
                            viewBox: "0 0 16 16",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                            })
                        })
                    ]
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./public/assets/icons/Vergleichangebot.svg
var Vergleichangebot = __webpack_require__(38849);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/ChevronLeftIcon.js
var ChevronLeftIcon = __webpack_require__(68121);
;// CONCATENATED MODULE: ./src/components/content/gallery.js





function Gallery(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items;
    var ref = (0,react.useState)(0), index = ref[0], setIndex = ref[1];
    var ref1 = (0,react.useState)(items[0]), current = ref1[0], setCurrent = ref1[1];
    var goTo = function(ind) {
        if (ind < 0) {
            setIndex(items.length - 1);
            setCurrent(items[items.length - 1]);
        } else if (ind + 1 > items.length) {
            setIndex(0);
            setCurrent(items[0]);
        } else {
            setIndex(ind);
            setCurrent(items[ind]);
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mb-5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
            className: "relative",
            children: [
                items.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "absolute right-5 top-3 text-3xl z-20 italic text-white drop-shadow pr-2 tracking-widest",
                            children: [
                                index + 1,
                                "/",
                                items.length
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronLeftIcon/* default */.Z, {
                            className: "transition-all duration-500 h-14 drop-shadow-lg absolute z-20 text-white hover:text-action left-6 top-1/2 -translate-y-1/2 cursor-pointer hover:left-4",
                            onClick: function() {
                                return goTo(index - 1);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRightIcon/* default */.Z, {
                            className: "transition-all duration-500 h-14 drop-shadow-lg absolute z-20 text-white hover:text-action right-6 top-1/2 -translate-y-1/2 cursor-pointer hover:right-4",
                            onClick: function() {
                                return goTo(index + 1);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                    src: (0,helper_image/* default */.Z)(current.image, {
                        w: 1200
                    }),
                    alt: current.alt || current.title,
                    layout: "responsive",
                    objectFit: "cover",
                    height: 500,
                    title: current.title,
                    width: 900
                }),
                current.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                    className: "w-full px-3 py-1 bg-action text-primary font-bold",
                    children: current.title
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/content/banner.js





function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function buildGallery() {
    var galleryObject = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var gallery = [];
    var rows = Array.isArray(galleryObject.rows) ? galleryObject.rows : Object.values(galleryObject.rows || {});
    Object.values(rows).forEach(function(i1) {
        Object.values(i1.columns).flat(1).forEach(function(i) {
            gallery.push(i);
        });
    });
    return gallery;
}
function Banner(param) {
    var item = param.item, _cols = param.cols, cols = _cols === void 0 ? 1 : _cols;
    var gallery = buildGallery(item.content.gallery || {});
    var image = gallery.length > 0 ? gallery[0] : null;
    if (item.appearance.backgroundImage && item.appearance.backgroundImage.length) {
        var ref;
        ref = _slicedToArray(item.appearance.backgroundImage, 1), image = ref[0], ref;
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-5 md:absolute md:inset-0 z-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-5 relative h-40 md:h-auto ".concat(cols === 1 ? 'md:col-span-2 lg:col-span-3' : 'md:col-span-1 lg:col-span-2'),
                        children: image && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                            src: (0,helper_image/* default */.Z)(image.publicUrl),
                            alt: image.properties.alternative,
                            title: image.properties.title,
                            layout: "fill",
                            objectFit: "cover"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden md:block bg-gray-100 ".concat(cols === 1 ? 'md:col-span-3 lg:col-span-2' : 'md:col-span-4 lg:col-span-3')
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-7xl mx-auto w-full grid md:grid-cols-5 grid-cols-1 md:gap-5 lg:gap-8 relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(cols === 1 ? 'md:col-span-2 lg:col-span-3' : 'md:col-span-1 lg:col-span-2')
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-gray-100 ".concat(cols === 1 ? 'px-10 py-10 md:col-span-3 lg:col-span-2' : 'px-5 py-10 md:col-span-4 lg:col-span-3'),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(headline/* default */.Z, {
                                after: item.content.suffix,
                                before: item.content.prefix,
                                tag: item.content.headerLayout || 2,
                                children: item.content.header
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-5 lg:columns-2 prose text-justify",
                                dangerouslySetInnerHTML: {
                                    __html: item.content.bodytext
                                }
                            }),
                            item.content.headerLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_button/* default */.Z, {
                                href: item.content.headerLink.href,
                                children: item.content.headerLink.title || 'Mehr zum Thema'
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/content/content.js













function content_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function content_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function content_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function content_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function content_slicedToArray(arr, i) {
    return content_arrayWithHoles(arr) || content_iterableToArrayLimit(arr, i) || content_unsupportedIterableToArray(arr, i) || content_nonIterableRest();
}
function content_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return content_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return content_arrayLikeToArray(o, minLen);
}
function content_buildGallery() {
    var galleryObject = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var gallery = [];
    var rows = Array.isArray(galleryObject.rows) ? galleryObject.rows : Object.values(galleryObject.rows || {});
    Object.values(rows).forEach(function(i1) {
        Object.values(i1.columns).flat(1).forEach(function(i) {
            gallery.push({
                image: (0,helper_image/* default */.Z)(i.publicUrl),
                title: i.properties.title,
                alt: i.properties.alternative
            });
        });
    });
    return gallery;
}
function ActionButton(param) {
    var item = param.item;
    return item.headerLink && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_button/* default */.Z, {
            width: "w-auto",
            href: item.headerLink.href,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: item.headerLink.title || 'Mehr zum Thema'
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRightIcon/* default */.Z, {
                        className: "w-5 text-primary"
                    })
                ]
            })
        })
    });
}
function generateToC(elements) {
    var list = [];
    elements.forEach(function(i, k) {
        if (k === 0) {
            return;
        }
        if (i.type === 'header') {
            list.push({
                title: [
                    i.content.prefix,
                    i.content.header,
                    i.content.suffix
                ].join(' '),
                id: "ce-".concat(k)
            });
        }
        if (i.type === 'accordion') {
            list.push({
                title: i.content.header,
                id: "ce-".concat(k)
            });
        }
        if (i.type === 'text' || i.type === 'textpic') {
            list.push({
                title: [
                    i.content.prefix,
                    i.content.header,
                    i.content.suffix
                ].join(' '),
                id: "ce-".concat(k)
            });
        }
        if (i.type === 'cards') {
            i.content.items.forEach(function(card) {
                list.push({
                    title: [
                        card.prefix,
                        card.header,
                        card.suffix
                    ].join(' '),
                    id: "ce-".concat(k)
                });
            });
        }
    });
    return list.filter(function(i) {
        return i.title.trim().length > 0;
    });
}
function BannerContentCol(param) {
    var item = param.item, _col = param.col, col = _col === void 0 ? 1 : _col;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, {
        cols: col,
        item: item
    }));
}
function HeroContent(param) {
    var item = param.item;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(hero/* default */.Z, {
        pretitle: item.content.subtitle,
        title: item.content.header,
        teaser: item.content.teaser,
        href: item.content.headerLink,
        label: item.content.headerLabel,
        photoUrl: item.content.thumbnail,
        toggle: false,
        after: item.content.suffix,
        before: item.content.prefix
    }));
}
function DefaultContent(param) {
    var item = param.item;
    var gallery = content_buildGallery(item.content.gallery || {});
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-7xl mx-auto w-full px-6 xl:px-0 lg:py-10 py-6",
        children: [
            item.content.header && /*#__PURE__*/ (0,jsx_runtime.jsx)(headline/* default */.Z, {
                after: item.content.suffix,
                before: item.content.prefix,
                tag: item.content.headerLayout || 2,
                children: item.content.header
            }),
            gallery.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Gallery, {
                items: gallery
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-lg mb-4 text-primary",
                dangerouslySetInnerHTML: {
                    __html: item.content.teaser
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "prose lg:columns-2",
                dangerouslySetInnerHTML: {
                    __html: item.content.bodytext
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton, {
                item: item.content
            })
        ]
    }));
}
function WideContent(param) {
    var item = param.item;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-gray-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-5xl mx-auto w-full px-6 xl:px-0 lg:py-10 py-6 text-center",
            children: [
                item.content.header && /*#__PURE__*/ (0,jsx_runtime.jsx)(headline/* default */.Z, {
                    after: item.content.suffix,
                    before: item.content.prefix,
                    tag: item.content.headerLayout || 2,
                    line: false,
                    children: item.content.header
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-lg mb-4 text-primary",
                    dangerouslySetInnerHTML: {
                        __html: item.content.teaser
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "prose",
                    dangerouslySetInnerHTML: {
                        __html: item.content.bodytext
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton, {
                    item: item.content
                })
            ]
        })
    }));
}
function LeftRightContent(param) {
    var position = param.position, item = param.item;
    var gallery = content_buildGallery(item.content.gallery || {});
    if (item.appearance.backgroundImage && item.appearance.backgroundImage.length) {
        var _backgroundImage = content_slicedToArray(item.appearance.backgroundImage, 1), image = _backgroundImage[0];
        gallery.unshift({
            image: (0,helper_image/* default */.Z)(image.publicUrl),
            alt: image.properties.alternative,
            title: image.properties.title
        });
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-7xl mx-auto w-full px-6 xl:px-0 lg:py-10 py-6 grid md:grid-cols-5 gap-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: position === 'left' ? 'order-1 md:col-span-2' : 'order-2 md:col-span-2',
                children: gallery.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Gallery, {
                    items: gallery
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: position === 'left' ? 'order-2 md:col-span-3' : 'order-1 md:col-span-3',
                children: [
                    item.content.header && /*#__PURE__*/ (0,jsx_runtime.jsx)(headline/* default */.Z, {
                        after: item.content.suffix,
                        before: item.content.prefix,
                        tag: item.content.headerLayout || 2,
                        children: item.content.header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "prose-lg mb-4 text-primary",
                        dangerouslySetInnerHTML: {
                            __html: item.content.teaser
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "prose",
                        dangerouslySetInnerHTML: {
                            __html: item.content.bodytext
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton, {
                        item: item.content
                    })
                ]
            })
        ]
    }));
}
function getFilterString(filter) {
    var string = '/yachtcharter?sort=pc';
    if (filter.country) {
        string += "&country=".concat(filter.country);
    }
    if (filter.sd) {
        string += "&sd=".concat(filter.sd);
    }
    if (filter.region_id) {
        string += "&region_id=".concat(filter.region_id);
    }
    if (filter.location_id) {
        string += "&location_id=".concat(filter.location_id);
    }
    return string;
}
function LandingPageContent(param) {
    var item = param.item, elements = param.elements, page = param.page;
    var list2 = generateToC(elements);
    var gallery = content_buildGallery(item.content.gallery || {});
    var filter = getFilterString(page.filter);
    var picture = 'https://assets.5-anker.com/fileadmin/br24de/uploads/regionen/mueritz/seenlandschaft.jpg';
    if (gallery.length !== 0) {
        picture = gallery[Math.floor(Math.random() * gallery.length)].image;
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-7xl mx-auto w-full px-6 xl:px-0 lg:py-10 py-6 grid md:grid-cols-3 grid-cols-1 lg:gap-8 gap-5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-span-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid grid-cols-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-3 md:col-span-2",
                            children: item.content.header && /*#__PURE__*/ (0,jsx_runtime.jsx)(headline/* default */.Z, {
                                after: item.content.suffix,
                                before: item.content.prefix,
                                tag: item.content.headerLayout || 2,
                                children: item.content.header
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "prose-lg mb-4 text-primary",
                        dangerouslySetInnerHTML: {
                            __html: item.content.teaser
                        }
                    }),
                    gallery.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Gallery, {
                        items: gallery
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "prose lg:columns-2",
                        dangerouslySetInnerHTML: {
                            __html: item.content.bodytext
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton, {
                        item: item.content
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOfContents, {
                        items: list2
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-12"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferItem, {
                        image: picture,
                        title: "Angebote",
                        price: "1549 €",
                        description: "Diverse Sonderangebote mit hohen Rabatten",
                        href: filter
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCard, {
                        icon: Vergleichangebot/* default */.Z,
                        title: "Individuelles Angebot jetzt anfordern",
                        href: "/kontakt"
                    })
                ]
            })
        ]
    }));
}
function Content(param) {
    var item = param.item, elements = param.elements, page = param.page;
    var ref, ref1, ref2;
    if (item.appearance.frameLayout === 'toc') return(/*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPageContent, {
        item: item,
        elements: elements,
        page: page
    }));
    if (item.appearance.frameLayout === 'stripe-1col') return(/*#__PURE__*/ (0,jsx_runtime.jsx)(BannerContentCol, {
        item: item
    }));
    if (item.appearance.frameLayout === 'stripe-2col') return(/*#__PURE__*/ (0,jsx_runtime.jsx)(BannerContentCol, {
        col: 2,
        item: item
    }));
    if (item.appearance.frameLayout === 'hero') return(/*#__PURE__*/ (0,jsx_runtime.jsx)(HeroContent, {
        item: item
    }));
    if (item.appearance.frameLayout === 'wide') return(/*#__PURE__*/ (0,jsx_runtime.jsx)(WideContent, {
        item: item
    }));
    if (item.content.headerPosition === 'center') return(/*#__PURE__*/ (0,jsx_runtime.jsx)(WideContent, {
        item: item
    }));
    if (((ref = item.content.gallery) === null || ref === void 0 ? void 0 : ref.position.horizontal) === 'left') {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(LeftRightContent, {
            item: item,
            position: "left"
        }));
    }
    if (((ref1 = item.content.gallery) === null || ref1 === void 0 ? void 0 : ref1.position.horizontal) === '' || ((ref2 = item.content.gallery) === null || ref2 === void 0 ? void 0 : ref2.position.horizontal) === 'right') {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(LeftRightContent, {
            item: item,
            position: "right"
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultContent, {
        item: item
    }));
};

;// CONCATENATED MODULE: ./src/components/content/cards.js






function cards_ActionButton(param) {
    var item = param.item;
    return item.linkTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_button/* default */.Z, {
            href: item.link.href,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: item.linkTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRightIcon/* default */.Z, {
                        className: "w-5 text-primary"
                    })
                ]
            })
        })
    });
}
function DefaultCardItem(param) {
    var item = param.item, tag = param.tag;
    var ElementTag = /^\d*$/.test(tag) ? "h".concat(tag) : tag;
    var image = item.image.length > 0 ? item.image[0] : null;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            item.header && /*#__PURE__*/ (0,jsx_runtime.jsx)(headline/* default */.Z, {
                after: item.suffix,
                before: item.prefix,
                tag: item.tag,
                children: item.header
            }),
            image && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                        src: (0,helper_image/* default */.Z)(image.publicUrl),
                        alt: image.properties.alternative || image.properties.title,
                        layout: "responsive",
                        objectFit: "cover",
                        height: 500,
                        title: image.properties.title,
                        width: 900
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ElementTag, {
                        className: "absolute left-0 font-semibold bottom-0 bg-action rounded-tr-2xl px-7 py-3 text-2xl uppercase",
                        children: item.header
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "prose",
                        dangerouslySetInnerHTML: {
                            __html: item.bodytext
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_ActionButton, {
                        item: item
                    })
                ]
            })
        ]
    }));
}
function DefaultCards(param) {
    var item = param.item;
    var tag = item.content.headerLayout || 2;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "max-w-7xl mx-auto w-full px-6 xl:px-0 lg:py-10 py-6",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "grid md:grid-cols-3 gap-y-10 md:gap-20",
            children: item.content.items.map(function(i, k) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(DefaultCardItem, {
                    item: i,
                    tag: tag + 1
                }, k);
            })
        })
    }));
}
function MasonryCardItem(param) {
    var item = param.item, tag = param.tag, index = param.index;
    var ElementTag = /^\d*$/.test(tag) ? "h".concat(tag) : tag;
    var image = item.image.length > 0 ? item.image[0] : null;
    return index === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid md:grid-cols-3 md:col-span-3 relative",
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative md:col-span-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                        src: (0,helper_image/* default */.Z)(image.publicUrl, {
                            w: 2000
                        }),
                        alt: image.properties.alternative || image.properties.title,
                        layout: "responsive",
                        objectFit: "cover",
                        height: 600,
                        title: image.properties.title,
                        width: 1000
                    }),
                    item.header && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute flex items-center flex-col justify-center flex-wrap break-after-all text-primary w-full max-w-[200px] right-0 font-semibold bottom-0 inset-y-0 bg-action px-3 text-center py-3 text-2xl uppercase",
                        children: [
                            item.subheader,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRightIcon/* default */.Z, {
                                className: "h-8 mt-5"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-6 bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ElementTag, {
                        className: "text-xl text-primary font-semibold block mb-2",
                        children: item.header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-base lg:leading-7 text-primary",
                        dangerouslySetInnerHTML: {
                            __html: item.bodytext
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_ActionButton, {
                        item: item
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " relative",
        children: [
            item.header && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center flex-row justify-center text-primary font-semibold bg-action px-7 py-3 text-2xl uppercase",
                children: [
                    item.subheader,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRightIcon/* default */.Z, {
                        className: "h-6 ml-3"
                    })
                ]
            }),
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                    src: (0,helper_image/* default */.Z)(image.publicUrl, {
                        w: 700
                    }),
                    alt: image.properties.alternative || image.properties.title,
                    layout: "responsive",
                    objectFit: "cover",
                    height: 400,
                    title: image.properties.title,
                    width: 900
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-4 bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ElementTag, {
                        className: "text-xl text-primary font-semibold block mb-2",
                        children: item.header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "prose text-primary",
                        dangerouslySetInnerHTML: {
                            __html: item.bodytext
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_ActionButton, {
                        item: item
                    })
                ]
            })
        ]
    });
}
function MasonryCards(param) {
    var item = param.item;
    var tag = item.content.headerLayout || 2;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-gray-50",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "max-w-7xl mx-auto w-full px-6 xl:px-0 lg:py-10 py-6",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid md:grid-cols-3 md:gap-5",
                children: item.content.items.map(function(i, k) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(MasonryCardItem, {
                        item: i,
                        tag: tag + 1,
                        index: k
                    }, k);
                })
            })
        })
    }));
}
function cards_Content(param) {
    var item = param.item, elements = param.elements;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: item.appearance.frameLayout === 'cards-masonry' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MasonryCards, {
            item: item,
            elements: elements
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultCards, {
            item: item
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/content/index.js















function Wrapper(element) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "max-w-7xl mx-auto w-full px-6 py-6 lg:py-4 xl:px-0",
        children: element
    }));
}
function RenderElements(param) {
    var elements = param.elements, page = param.page;
    var render = [];
    if (elements) {
        elements.forEach(function(i) {
            switch(i.type){
                case 'accordion':
                    render.push({
                        wrapped: true,
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(faq/* default */.Z, {
                            item: i
                        })
                    });
                    break;
                case 'header':
                    render.push({
                        wrapped: true,
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(headline/* default */.Z, {
                            tag: i.content.headerLayout || 2,
                            before: i.content.prefix,
                            after: i.content.suffix,
                            children: i.content.header
                        })
                    });
                    break;
                case 'text':
                case 'textpic':
                    render.push({
                        wrapped: false,
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                            elements: elements,
                            item: i,
                            page: page
                        })
                    });
                    break;
                case 'card_group':
                    if (i.appearance.frameLayout === 'cards-features') {
                        render.push({
                            wrapped: true,
                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Features, {
                                items: i.content.items
                            })
                        });
                    } else if (i.appearance.frameLayout === 'cards-topics') {
                        render.push({
                            wrapped: true,
                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopicSlider, {
                                item: i
                            })
                        });
                    } else {
                        render.push({
                            wrapped: false,
                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_Content, {
                                elements: elements,
                                item: i
                            })
                        });
                    }
                    break;
                case 'div':
                    render.push({
                        wrapped: true,
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                height: '50px'
                            }
                        })
                    });
                    break;
                case 'carousel_small':
                    render.push({
                        wrapped: true,
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {
                            item: i
                        })
                    });
                    break;
                case 'news_pi1':
                    var ref, ref1;
                    if (((ref = i.content.data) === null || ref === void 0 ? void 0 : (ref1 = ref.settings) === null || ref1 === void 0 ? void 0 : ref1.action) === 'list') {
                        render.push({
                            wrapped: true,
                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsList, {
                                item: i,
                                page: page
                            })
                        });
                    }
                    break;
                case 'headmore_cruise_slider':
                case 'headmore_offers_slider':
                    render.push({
                        wrapped: true,
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(cruise_slider/* default */.Z, {
                            searchQueryParams: i.content.data
                        })
                    });
                    break;
                case 'headmore_boats_slider':
                    render.push({
                        wrapped: true,
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoatSlider, {
                            searchQueryParams: i.content.data
                        })
                    });
                    break;
                case 'headmore_json':
                    var ref2;
                    if (((ref2 = i.content.data) === null || ref2 === void 0 ? void 0 : ref2.type) === 'faq_grouped') {
                        render.push({
                            wrapped: true,
                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqGrouped, {
                                items: i.content.data.items
                            })
                        });
                    }
                    break;
                case 'menu_card_list':
                    if (i.appearance.frameLayout === 'menu-cards-offer-slider') {
                        render.push({
                            wrapped: true,
                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_offer_slider/* default */.Z, {
                                contentItem: i.content.items
                            })
                        });
                    } else {
                        render.push({
                            wrapped: true,
                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferList, {
                                items: i.content.items
                            })
                        });
                    }
                    break;
                default:
                    break;
            }
        });
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: render.map(function(element, k) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "ce-".concat(k),
                children: element.wrapped ? Wrapper(element.content) : element.content
            }, k);
        })
    }));
}
/* harmony default export */ var content = ((/* unused pure expression or super */ null && (RenderElements)));

// EXTERNAL MODULE: ./src/components/globals/breadcrumbs.js
var globals_breadcrumbs = __webpack_require__(21859);
;// CONCATENATED MODULE: ./src/components/page-types/post.js








function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function post_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function post_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            post_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var getServerSideProps = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param) {
        var post, page, locale;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    post = param.post, page = param.page, locale = param.locale;
                    return _ctx.abrupt("return", {
                        props: {
                            post: post,
                            page: page,
                            locale: locale
                        }
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getServerSideProps(_) {
        return _ref.apply(this, arguments);
    };
}();
function Post(param) {
    var post = param.post, page = param.page;
    var ref, ref1, ref2;
    var breadcrumbs = page.breadcrumbs;
    var postData = post.content.data.detail;
    ;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {
                title: postData.title,
                description: postData.metaData.description,
                image: postData.photo_url,
                canonicalUrl: (ref = page.meta.canonical) === null || ref === void 0 ? void 0 : ref.href
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", post_objectSpread({}, (0,src/* jsonLdScriptProps */.h6)({
                '@context': 'https://schema.org',
                '@type': 'Article',
                headline: postData.title,
                image: postData.photo_url ? [
                    (0,helper_image/* default */.Z)(postData.photo_url), 
                ] : [],
                datePublished: postData.created_at,
                dateModified: postData.updated_at,
                publisher: {
                    '@type': 'Organization',
                    name: 'CharterCheck',
                    url: '/'
                },
                author: {
                    '@type': 'Organization',
                    name: 'CharterCheck',
                    url: '/'
                }
            }))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero/* default */.Z, {
                title: postData.title,
                teaser: postData.teaser,
                pretitle: postData.subtitle,
                photoUrl: (ref1 = postData.media[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.images) === null || ref2 === void 0 ? void 0 : ref2.defaultImage,
                toggle: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-3xl mx-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full px-6 xl:px-0 mb-10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(globals_breadcrumbs/* default */.Z, {
                            items: breadcrumbs
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderElements, {
                        elements: post.content.data.contentElements,
                        page: page
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 5 modules
var transition = __webpack_require__(33587);
// EXTERNAL MODULE: ./src/components/search/index.js + 17 modules
var components_search = __webpack_require__(74675);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./app.config.js
var app_config = __webpack_require__(48387);
// EXTERNAL MODULE: ./src/utils/defaultDate.js
var defaultDate = __webpack_require__(28091);
;// CONCATENATED MODULE: ./src/components/page-types/page.js













function page_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function page_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                page_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                page_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function page_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function page_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            page_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var page_getServerSideProps = function() {
    var _ref = page_asyncToGenerator(runtime_default().mark(function _callee(param) {
        var page, locale, params, query, serverSideTranslations, isTypeSearch, filter, search;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    page = param.page, locale = param.locale, params = param.params, query = param.query, serverSideTranslations = param.serverSideTranslations;
                    isTypeSearch = Object.keys(page.filter).length > 0;
                    filter = {};
                    search = {
                        data: [],
                        meta: {
                            total: 0,
                            to: 1,
                            from: 1
                        }
                    };
                    if (!isTypeSearch) {
                        _ctx.next = 10;
                        break;
                    }
                    filter = page_objectSpread({
                        group: 'model',
                        typ: 'w',
                        duration: 7,
                        page: 1,
                        channel: app_config/* default.channel */.Z.channel,
                        sort: 'date_from'
                    }, page === null || page === void 0 ? void 0 : page.filter, query);
                    if (!filter.date_from) {
                        filter.date_from = (0,defaultDate/* default */.Z)();
                        filter.date_to = moment_default()(filter.date_from).add(3, 'weeks').format('YYYY-MM-DD');
                    }
                    _ctx.next = 9;
                    return (0,connect/* fetchAPI */.Io)('/search', filter);
                case 9:
                    // filter = omit('slug', filter);
                    search = _ctx.sent;
                case 10:
                    _ctx.t0 = page_objectSpread;
                    _ctx.t1 = {
                        page: page,
                        search: search,
                        filter: filter,
                        locale: locale
                    };
                    _ctx.next = 14;
                    return serverSideTranslations(locale, [
                        'boat',
                        'common',
                        'footer'
                    ]);
                case 14:
                    _ctx.t2 = _ctx.sent;
                    _ctx.t3 = (0, _ctx.t0)(_ctx.t1, _ctx.t2);
                    return _ctx.abrupt("return", {
                        props: _ctx.t3
                    });
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getServerSideProps(_) {
        return _ref.apply(this, arguments);
    };
}();
function Page(param) {
    var page = param.page, search = param.search, filter = param.filter;
    var ref;
    var ref1 = (0,react.useState)(false), checked = ref1[0], setChecked = ref1[1];
    var items = Object.values(page.content).flat(1).filter(function(i) {
        return i !== null;
    });
    var showToggle = (!page.options || !page.options.hideToggle) && items.length > 0;
    var buttonLabel = !page.options || !page.options.searchButton ? 'Revierinformationen' : page.options.searchButton;
    var isTypeSearch = Object.keys(page.filter).length > 0;
    var ref2 = (0,react.useState)((search === null || search === void 0 ? void 0 : search.data) || []), searchData = ref2[0], setSearchData = ref2[1];
    var ref3 = (0,react.useState)((search === null || search === void 0 ? void 0 : search.meta) || {}), searchMeta = ref3[0], setSearchMeta = ref3[1];
    (0,react.useEffect)(function() {
        setSearchData((search === null || search === void 0 ? void 0 : search.data) || []);
        setSearchMeta((search === null || search === void 0 ? void 0 : search.meta) || {});
    }, [
        search
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {
                title: page.meta.title,
                description: page.meta.description,
                canonicalUrl: (ref = page.meta.canonical) === null || ref === void 0 ? void 0 : ref.href,
                image: page.meta.thumbnail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero/* default */.Z, {
                title: page.meta.title,
                teaser: page.meta.abstract,
                pretitle: page.meta.subtitle,
                checked: checked,
                setChecked: setChecked,
                photoUrl: page.meta.thumbnail,
                switchLabel: buttonLabel,
                toggle: showToggle && isTypeSearch
            }),
            isTypeSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                show: !checked,
                enter: "transition-all ease-out duration-200",
                enterFrom: "opacity-0",
                enterTo: "opacity-100 ",
                leave: "transition-all ease-in duration-150",
                leaveFrom: "opacity-100 ",
                leaveTo: "opacity-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "-mt-24 md:-mt-30",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_search/* default */.Z, {
                        data: searchData,
                        meta: searchMeta,
                        filter: filter,
                        setData: setSearchData,
                        setMeta: setSearchMeta
                    })
                })
            }),
            !isTypeSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-3"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-w-7xl mx-auto w-full px-6 xl:px-0 mt-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(globals_breadcrumbs/* default */.Z, {
                    items: page.breadcrumbs
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderElements, {
                elements: items,
                page: page
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/pages/_error.js
var _error = __webpack_require__(91736);
;// CONCATENATED MODULE: ./src/pages/[...slug].js




function _slug_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _slug_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _slug_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var __N_SSP = true;
function RenderPage(_param) {
    var post = _param.post, page = _param.page, errorCode = _param.errorCode, props = _objectWithoutProperties(_param, [
        "post",
        "page",
        "errorCode"
    ]);
    if (errorCode) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(_error["default"], {
            statusCode: errorCode,
            title: "Seite nicht gefunden"
        }));
    }
    ;
    if (post) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Post, _slug_objectSpread({
            post: post,
            page: page
        }, props)));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Page, _slug_objectSpread({
        page: page
    }, props)));
};


/***/ }),

/***/ 91736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12918);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92876);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19985);
/* harmony import */ var _UserErrorPage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51190);





function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function MyError(param) {
    var statusCode = param.statusCode, hasGetInitialPropsRun = param.hasGetInitialPropsRun, err = param.err;
    if (!hasGetInitialPropsRun && err) {
        // getInitialProps is not called in case of
        // https://github.com/vercel/next.js/issues/8592. As a workaround, we pass
        // err via _app.js so it can be captured
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(err);
    // Flushing is not required in this case as it only happens on the client
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_UserErrorPage__WEBPACK_IMPORTED_MODULE_3__["default"], {
        statusCode: statusCode
    }));
}
MyError.getInitialProps = (function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(context) {
        var errorInitialProps, res, err, asPath;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return next_error__WEBPACK_IMPORTED_MODULE_2__["default"].getInitialProps(context);
                case 2:
                    errorInitialProps = _ctx.sent;
                    res = context.res, err = context.err, asPath = context.asPath;
                    // Workaround for https://github.com/vercel/next.js/issues/8592, mark when
                    // getInitialProps has run
                    errorInitialProps.hasGetInitialPropsRun = true;
                    if (!((res === null || res === void 0 ? void 0 : res.statusCode) === 404)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", errorInitialProps);
                case 7:
                    if (!err) {
                        _ctx.next = 12;
                        break;
                    }
                    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(err);
                    _ctx.next = 11;
                    return _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .flush */ .yl(2000);
                case 11:
                    return _ctx.abrupt("return", errorInitialProps);
                case 12:
                    // If this point is reached, getInitialProps was called without any
                    // information about what the error might be. This is unexpected and may
                    // indicate a bug introduced in Next.js, so record it in Sentry
                    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(new Error("_error.js getInitialProps missing data at path: ".concat(asPath)));
                    _ctx.next = 15;
                    return _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .flush */ .yl(2000);
                case 15:
                    return _ctx.abrupt("return", errorInitialProps);
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(context) {
        return _ref.apply(this, arguments);
    };
})();
/* harmony default export */ __webpack_exports__["default"] = (MyError);


/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(89185)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [141,399,840,550,541,749,501,419,96,423,68,774,888,179], function() { return __webpack_exec__(84459); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);